import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createSelector } from '@ngrx/store';
import { OemRooftopLink } from '@quorum/models/xs-resource';
import { svcDropdownsFeatureSelector } from '../svc-dropdowns-feature.selector';
export interface RooftopsState extends EntityState<OemRooftopLink> {}

export const rooftopsAdapter: EntityAdapter<OemRooftopLink> = createEntityAdapter<OemRooftopLink>({
  selectId: (rooftop: OemRooftopLink) => rooftop.id,
});

export const initialState: RooftopsState = rooftopsAdapter.getInitialState({ loading: true });
export const rooftopsSelector = createSelector(svcDropdownsFeatureSelector, (state: any) => state.rooftops);

export const { selectIds, selectEntities, selectAll, selectTotal } = rooftopsAdapter.getSelectors(rooftopsSelector);
